<template>
  <generic-container
    :title="$t('arguments')"
    icon="code"
    style="margin-top: 15px"
  >
    <div class="ui form">
      <div class="field" v-for="(prm, pidx) in task_params" :key="pidx">
        <label>{{ prm.name }}</label>
        <input type="text" v-model="task_params[pidx].value" />
      </div>
    </div>
    <!-- <pre>{{ task_params }}</pre> -->
  </generic-container>
</template>
<script>
import GenericContainer from "@/components/GenericContainer";

export default {
  name: "NgineComposerHumanTaskTesterArguments",
  components: { GenericContainer },
  data() {
    return {
      task_params: {},
    };
  },
  computed: {},
  methods: {
    init(data) {
      let vm = this;

      vm.task_params = Object.keys(data).map((k) => {
        return { name: k, value: data[k] || "" };
      });
    },
  },
  mounted() {},
  created() {},
  watch: {},
};
</script>

<style></style>
